import { On3IconEmbed } from '@on3/icons';
import { Popover } from '@on3/ui-lib/components/Popover';
import { handleKeyDown } from '@on3/ui-lib/utils/accessibility/keyDown';
import clsx from 'clsx';
import { useRef, useState } from 'react';

import styles from './EmbedButton.module.scss';

export const EmbedButton = ({
  embedCode,
  buttonText = 'Embed',
  className,
}: {
  title: string;
  embedCode: string;
  buttonText?: string;
  className?: string;
}) => {
  const ref = useRef<HTMLButtonElement>(null);
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const handleCopyEmbed = () => {
    setIsCopied(true);
    navigator.clipboard.writeText(embedCode);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <Popover className={styles.block}>
      {({ isOpen, setIsOpen, Wrapper }) => (
        <>
          <button
            aria-controls={isOpen ? 'embed-link-popover' : undefined}
            aria-expanded={isOpen}
            aria-haspopup="true"
            aria-label="click to copy embed code"
            aria-pressed={isOpen}
            className={clsx(styles.embedButton, className)}
            onClick={() => setIsOpen(!isOpen)}
            ref={ref}
          >
            <On3IconEmbed />
            {buttonText}
          </button>
          {isOpen && (
            <Wrapper
              className={styles.popover}
              controlRef={ref}
              id="embed-link-popover"
              role="tooltip"
            >
              <div className={styles.inner}>
                <h2 className={styles.title}>Embed Code</h2>
                <div
                  onClick={handleCopyEmbed}
                  onKeyDown={() => handleKeyDown(handleCopyEmbed)}
                  role="button"
                  tabIndex={0}
                >
                  <pre className={styles.embedCode}>
                    <code>{embedCode}</code>
                  </pre>
                </div>
                <button
                  className={styles.copyEmbedButton}
                  disabled={isCopied}
                  onClick={handleCopyEmbed}
                >
                  {isCopied ? 'Copied!' : 'Copy Embed Code'}
                </button>
              </div>
            </Wrapper>
          )}
        </>
      )}
    </Popover>
  );
};
